/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';

const propTypes = (member) => ({
    ...member,
    updatePaymentMethodCode: PropTypes.func.isRequired,
    updateShippingAddress: PropTypes.func.isRequired,
    updateShippingMethodCode: PropTypes.func.isRequired,
    updateBillingSameAsShipping: PropTypes.func.isRequired,
    updateBillingAddressId: PropTypes.func.isRequired,
    updateBillingAddress: PropTypes.func.isRequired
});

const clearCheckoutFormFields = (_args, _callback, instance) => {
    const {
        updatePaymentMethodCode,
        updateShippingAddress,
        updateShippingMethodCode,
        updateBillingSameAsShipping,
        updateBillingAddressId,
        updateBillingAddress
    } = instance.props;

    updatePaymentMethodCode('');
    updateShippingAddress({});
    updateShippingMethodCode('');
    updateBillingSameAsShipping(false);
    updateBillingAddressId(0);
    updateBillingAddress({});
};

export default {
    'Component/CheckoutSuccess/Component': {
        'static-member': {
            propTypes
        },
        'member-function': {
            componentDidMount: clearCheckoutFormFields
        }
    }
};
